import React from 'react';
import TextInput from '../TextInput/TextInput';

/** @import {TelInputProps} from './TelInputTypes' */

/** @extends TextInput<TelInputProps> */
class TelInput extends TextInput {
    handleChange = (/** @type {React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>} */ e, /** @type {boolean} */ triggerChange = true) => {
        if (this.props.nonEditable) return;

        let value = e.target.value;
        if (value.length <= this.props.prependValue.length) {
            value = this.props.prependValue;
        }

        value = value.replace(/[^0-9+]/g, '');

        if (this.props.prependValue) {
            value = value.replace(this.props.prependValue + '0', this.props.prependValue);
        }

        this.setState({value: value});
        triggerChange && this.props.onChange && this.props.onChange(value);
    };

    format = (/** @type {string} */ phoneNumber) => {
        return phoneNumber;
    };

    render() {
        return (
            <input
                name={this.props.name}
                className={this.getClassNames()}
                type='tel'
                placeholder={this.props.placeholder}
                onChange={this.handleChange}
                pattern={this.props.pattern}
                disabled={this.props.disabled}
                ref={this.props.inputRef}
                maxLength={this.props.maxLength}
                value={this.format(this.props.value || this.props.prependValue)}
                data-test={this.props.name}
            />
        );
    }
}

export default TelInput;
